export const defaultLngCode = 'en';
export const defaultCurrencyCode = 'USD';
export const defaultCurrencySymbol = '$';
